import React, { useEffect, Suspense, lazy } from "react";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = lazy(() => import("./components/Header/Header"));
const Footer = lazy(() => import("./components/Footer/Footer"));
const FloatingButton = lazy(() => import("./components/FloatingButton/FloatingButton"));
const Error404Page = lazy(() => import("./components/Error404Page/Error404Page"));

const IndexPage = lazy(() => import("./pages/IndexPage/IndexPage"));
const BasicPace = lazy(() => import("./pages/BasicPace/BasicPace"));
const WanjinshiMarathon = lazy(() => import("./pages/WanjinshiMarathon/WanjinshiMarathon"));
const NagoyaMarathon = lazy(() => import("./pages/NagoyaMarathon/NagoyaMarathon"));
const Scbmarathon = lazy(() => import("./pages/Scbmarathon/Scbmarathon"));
const TaipeiMarathon = lazy(() => import("./pages/TaipeiMarathonTimer/TaipeiMarathon"));
const ExpoCupon = lazy(() => import("./pages/ExpoCupon/ExpoCupon"));
const AboutMaoMao = lazy(() => import("./pages/AboutMaoMao/AboutMaoMao"));
const AboutMarathonTimer = lazy(() => import("./pages/AboutMarathonTimer/AboutMarathonTimer"));
const Osaka2025 = lazy(() => import("./pages/2025Osaka/Osaka2025"));
const Tokyo2025 = lazy(() => import("./pages/2025Tokyo/Tokyo2025"));
const GroupRegistration = lazy(() => import("./pages/GroupRegistration/GroupRegistration"));

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App() {
    return (
        <Router>
            <Suspense fallback={<div className=""></div>}>
                <div className="App">
                    <div className="top-page">
                        <Header />
                        <main>
                            <Routes>
                                <Route path="/" element={<IndexPage />} />
                                <Route path="/Basic" element={<BasicPace />} />
                                <Route path="/Osaka2025" element={<Osaka2025 />} />
                                <Route path="/Tokyo2025" element={<Tokyo2025 />} />
                                <Route path="/WanjinshiMarathon" element={<WanjinshiMarathon />} />
                                <Route path="/NagoyaMarathon" element={<NagoyaMarathon />} />
                                <Route path="/Scbmarathon" element={<Scbmarathon />} />
                                <Route path="/TaipeiMarathon" element={<TaipeiMarathon />} />
                                <Route
                                    path="/AboutMarathonTimer"
                                    element={<AboutMarathonTimer />}
                                />
                                <Route path="/ExpoCupon" element={<ExpoCupon />} />
                                <Route path="/AboutMaoMao" element={<AboutMaoMao />} />
                                <Route path="/GroupRegistration" element={<GroupRegistration />} />
                                <Route path="*" element={<Error404Page />} />
                            </Routes>
                            <ScrollToTop />
                        </main>
                        <Footer />
                        <FloatingButton />
                    </div>
                </div>
            </Suspense>
        </Router>
    );
}

export default App;
